module.exports = __webpack_public_path__ + "static/media/bg-cowboys.253fd430.jpg";